<template>
  <Modal
    ref="modalRef"
    content-id="catalog-product"
    :clickToClose="true"
    :showIcon="false"
    :modalStyle="{ maxWidth: 'calc(100vw - 32px)', width: '1328px' }"
    :style="modalStyle"
    :outsideScrollDisabled="true"
    @modalClosed="onModalClosed"
  >
    <template #body>
      <div class="catalog-product-modal">
        <CatalogProductCard
          v-if="images && images.length"
          :attributes="selectedProduct?.attributes"
          :comissionRate="selectedProduct?.commission"
          :toolTipText="toolTipText"
          :images="images"
          :style="{ marginBottom: '24px' }"
        />

        <div class="catalog-product-main-wrapper">
          <h2 class="modal-product-title" @click="$emit('go-to-product')">
            {{ selectedProduct.productTitle || selectedProduct.variantTitle }}
          </h2>

          <slot name="selectable-area"></slot>

          <slot name="bulk-operations"></slot>

          <slot name="table"></slot>

          <div class="modal-bottom">
            <slot name="footer">
              <div class="modal-bottom-alert">
                <img src="@/assets/images/icons/info-circle.svg" />
                <p class="modal-bottom-text">
                  {{ footerText }}
                </p>
              </div>
              <Button
                primary
                lg
                style="width: auto"
                :disabled="isOpenSaleProductBtnDisabled"
                @click="handleSaveClick"
              >
                {{ submitButtonText }}
              </Button>
            </slot>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref } from "vue";
import { Button, Modal, CatalogProductCard } from "@n11/so-ui-components";
import { useStore } from "vuex";

const props = defineProps({
  selectedProduct: { type: Object, default: null },
  images: { type: Array, default: () => [] },
  modalStyle: { type: Object, default: () => ({}) },
  isOpenSaleProductBtnDisabled: { type: Boolean, default: false },
  isSubmitting: { type: Boolean, default: false },
  toolTipText: {
    type: String,
    default:
      "Komisyon oranı; mağazanıza, ürün kategorisine ve katıldığınız kampanyalara göre değişiklik gösterir.",
  },
  mode: {
    type: String,
    default: 'add-catalog', // 'add-catalog' | 'add-variant'
  },
});

const emit = defineEmits(["open-sale", "go-to-product", "modal-closed", "handle-save"]);

const store = useStore();
const modalRef = ref(null);

const onModalClosed = () => {
  emit("modal-closed");
};

const openModal = () => modalRef.value?.openModal?.();
const hiddenModal = () => modalRef.value?.hiddenModal?.();

const handleSaveClick = () => {
  emit('handle-save');
};

defineExpose({ openModal, hiddenModal });
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.catalog-product-modal {
  display: flex;
  gap: 16px;
  color: $colorN80;
  text-align: left;

  .catalog-product-main-wrapper {
    position: relative;
    width: 100%;
    padding-bottom: 64px;
  }

  .modal-product-title {
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.02px;
    line-height: 26px;
    margin-bottom: 24px;
    cursor: pointer;
    text-decoration: underline;
  }

  .modal-bottom {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    position: absolute;
    bottom: 0;
    width: 100%;

    .modal-bottom-alert {
      font-size: 13px;
      letter-spacing: -0.05px;
      width: 100%;
      padding: 12px 16px;
      display: flex;
      align-items: center;
      border-radius: 6px;
      gap: 12px;
      background-color: $colorB05;

      img {
        width: 24px;
        height: 24px;
      }
    }

    .modal-bottom-text {
      b {
        font-weight: 700;
      }
    }
  }
}
</style>
